export default "__VITE_ASSET__BbWgZchq__"